var _path, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumero3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8796 18.16C15.5036 18.16 17.1676 16.848 17.1676 14.736C17.1676 13.216 16.2876 12.272 14.9596 11.968C16.0636 11.552 16.8156 10.768 16.8156 9.472C16.8156 7.776 15.4236 6.4 13.0396 6.4C10.5916 6.4 9.10363 7.92 8.99163 9.904H10.8796C11.0076 8.752 11.7916 8.016 13.0076 8.016C14.1916 8.016 14.7836 8.704 14.7836 9.632C14.7836 10.704 14.1916 11.312 12.8796 11.312H12.0636V12.832H12.9436C14.3356 12.832 15.0076 13.456 15.0076 14.704C15.0076 15.84 14.3196 16.56 12.8316 16.56C11.2956 16.56 10.6236 15.664 10.5116 14.464H8.57563C8.67163 16.656 10.1596 18.16 12.8796 18.16Z",
    fill: "url(#paint0_linear_538_2989)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12.5,
    r: 12,
    stroke: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_2989",
    x1: 9,
    y1: 22,
    x2: 22.5906,
    y2: 16.2776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628533,
    stopColor: "#F23A3A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumero3);
export default __webpack_public_path__ + "static/media/numero3.43351b1623246c15ddcd282749c4fefa.svg";
export { ForwardRef as ReactComponent };